import { Controller } from "@hotwired/stimulus"

// Keeps the print-preview sheet in sync with the selected size: the
// preview's aspect ratio always matches the physical sheet being bought.
export default class extends Controller {
  static targets = ["sheet", "caption"]

  update(event) {
    const { width, height, label } = event.params
    this.sheetTarget.style.aspectRatio = `${width} / ${height}`
    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = `Shown at ${label}`
    }
  }
}
